/**
 * Datos de planes que el catálogo necesita y que hoy viven **inline en
 * `Paywall.tsx`** (`ultraTiers` y `planOrder`). Ver ADR-2026-07-29-pais-browser-fallback-precios-cuando.
 *
 * Existe porque el catálogo ya se monta desde tres lugares (`/subscription`,
 * `/pricing-dev` y el sheet del alta) y cada uno estaba copiando las mismas dos
 * tablas. Acá quedan en un solo archivo, verificado idéntico a las copias de
 * `Paywall`.
 *
 * `Paywall.tsx` **no** se tocó a propósito: sus copias son parte del cálculo de
 * precios que el rediseño decidió no mover (ver el encabezado de
 * `buildPlanViews`). Si algún día se migra, este es el destino.
 */
import type { UltraTier } from './buildPlanViews';

/** Tiers del plan Ultra, en el orden del slider (500 / 1.000 / 2.000 imágenes). */
export const ULTRA_TIERS: UltraTier[] = [
  { images: 500, videos: 40, price: 109999, planId: 'enterprise1' },
  { images: 1000, videos: 80, price: 209999, planId: 'enterprise2' },
  { images: 2000, videos: 160, price: 399999, planId: 'enterprise3' },
];

/** Jerarquía de planes, para decidir upgrade/downgrade en las cards. */
export const PLAN_ORDER: Record<string, number> = {
  gratis: 0,
  emprendimiento: 1,
  negocio: 2,
  enterprise: 3,
  enterprise1: 3.1,
  enterprise2: 3.2,
  enterprise3: 3.3,
  experto: 4,
};
